import * as v from 'valibot';
import { t } from 'i18next';

export const SearchTermSchema = v.union([ v.null(), v.pipe(
	v.string(),
	v.minLength(3, t('Zadejte alespoň %count% znak.', { count: 3 })),
) ]);

export const TrimmedSearchTermSchema = v.union([ v.null(), v.pipe(
	v.string(),
	v.check(input => input.trim().length >= 3, t('Zadejte alespoň %count% znak.', { count: 3 })),
) ]);

export const RequiredStringSchema = v.pipe(
	v.string(t('Zadejte text.')),
	v.trim(),
	v.nonEmpty(t('Zadejte text.')),
);

export const ResponseWithIdSchema = v.object({
	id: v.number(),
});

export const IdSchema = v.pipe(v.number(), v.integer(), v.minValue(0));

export const UuidSchema = v.pipe(v.string(), v.uuid());

export const PhoneNumberSchema = v.pipe(
	v.string(),
	v.regex(
		/^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/,
		t('Zadejte platné telefonní číslo včetně mezinárodní předvolby.'),
	),
);
